export const TEMPLATE_SIZE_OPTIONS = {
  LANDSCAPE: 'Landscape (16:9)',
  PORTRAIT: 'Portrait (9:16)',
  SQUARE: 'Square (1:1)'
};
